import { render, staticRenderFns } from "./emailContactsDialog.vue?vue&type=template&id=e1e20b74&lang=pug"
import script from "./emailContactsDialog.vue?vue&type=script&lang=js"
export * from "./emailContactsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports